<template>
  <aside class="dashboard-nav" :class="{ 'is-collapsed': collapsed && canCollapse }">
    <div class="dashboard-nav-items">
      <button
        type="button"
        class="dashboard-nav-action dashboard-nav-expandable"
        :class="{ 'is-active': activePanel === 'tasks' }"
        @click="$emit('toggle-panel', 'tasks')"
        :title="s__('Dashboard|Tasks')"
      >
        <span class="dashboard-nav-icon"><ActivityIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Dashboard|Tasks') }}</span>
        <NavMetaStateIcon :state="activePanel === 'tasks' ? 'expanded' : 'collapsed'" />
      </button>

      <a
        :href="dashboardUrl"
        class="dashboard-nav-action dashboard-nav-link"
        :title="s__('Dashboard|Dashboard')"
      >
        <span class="dashboard-nav-icon"><FaviconMarkIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Dashboard|Dashboard') }}</span>
        <NavMetaStateIcon state="open" />
      </a>

      <button
        type="button"
        class="dashboard-nav-action dashboard-nav-expandable"
        :class="{ 'is-active': activePanel === 'boards' }"
        @click="$emit('toggle-panel', 'boards')"
        :title="s__('Boards|Project boards')"
      >
        <span class="dashboard-nav-icon"><KanbanIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Boards|Project boards') }}</span>
        <NavMetaStateIcon :state="activePanel === 'boards' ? 'expanded' : 'collapsed'" />
      </button>

      <button
        v-if="canManageProject"
        type="button"
        class="dashboard-nav-action dashboard-nav-expandable"
        :class="{ 'is-active': activePanel === 'attachments' }"
        @click="$emit('toggle-panel', 'attachments')"
        :title="s__('Attachments|Project files')"
      >
        <span class="dashboard-nav-icon"><FileIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Attachments|Project files') }}</span>
        <NavMetaStateIcon :state="activePanel === 'attachments' ? 'expanded' : 'collapsed'" />
      </button>

      <button
        type="button"
        class="dashboard-nav-action dashboard-nav-expandable"
        :class="{ 'is-active': activePanel === 'reports' }"
        @click="$emit('toggle-panel', 'reports')"
        :title="__('Report Constructor')"
      >
        <span class="dashboard-nav-icon"><ReportIcon /></span>
        <span class="dashboard-nav-title">{{ __('Report Constructor') }}</span>
        <NavMetaStateIcon :state="activePanel === 'reports' ? 'expanded' : 'collapsed'" />
      </button>

      <a
        v-if="canManageProject"
        :href="projectSettingsUrl"
        class="dashboard-nav-action dashboard-nav-link"
        :title="s__('Project|Project settings')"
      >
        <span class="dashboard-nav-icon"><SettingsIcon /></span>
        <span class="dashboard-nav-title">{{ s__('Project|Project settings') }}</span>
        <NavMetaStateIcon state="open" />
      </a>
    </div>

    <div class="dashboard-nav-bottom-controls">
      <DashboardNavCornerControls
        :can-toggle-full-width="canToggleFullWidth"
        :is-full-width="isFullWidth"
        :can-collapse="canCollapse"
        :collapsed="collapsed"
        @toggle-full-width="$emit('toggle-full-width')"
        @toggle-collapse="$emit('toggle-collapse')"
      />
    </div>
  </aside>
</template>

<script setup>
import { __, s__ } from '@/locale'
import ActivityIcon from '../../common/icons/ActivityIcon.vue'
import DashboardNavCornerControls from '../../common/DashboardNavCornerControls.vue'
import FaviconMarkIcon from '../../common/icons/FaviconMarkIcon.vue'
import FileIcon from '../../common/icons/FileIcon.vue'
import KanbanIcon from '../../common/icons/KanbanIcon.vue'
import SettingsIcon from '../../common/icons/SettingsIcon.vue'
import NavMetaStateIcon from '../../common/NavMetaStateIcon.vue'
import ReportIcon from '../../common/icons/ReportIcon.vue'

defineProps({
  activePanel: { type: String, default: null },
  collapsed: { type: Boolean, default: false },
  canCollapse: { type: Boolean, default: false },
  isFullWidth: { type: Boolean, default: false },
  canToggleFullWidth: { type: Boolean, default: false },
  canManageProject: { type: Boolean, default: false },
  dashboardUrl: { type: String, required: true },
  projectSettingsUrl: { type: String, required: true },
})

defineEmits(['toggle-panel', 'toggle-collapse', 'toggle-full-width'])
</script>

<style scoped>
.dashboard-nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dashboard-nav-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
